import React from 'react';
import { Skeleton } from 'src/components/ui/skeleton';

export const PersonaTabSkeleton = () => (
  <div className={'flex flex-col gap-5 w-full h-full'}>
    <Skeleton className={'w-1/4 h-[5%]'} />
    <Skeleton className={'w-full h-[15%]'} />
    <Skeleton className={'w-1/4 h-[5%]'} />
    <Skeleton className={'w-1/2 h-[5%]'} />
    <Skeleton className={'w-full h-[10%]'} />
    <Skeleton className={'w-1/4 h-[5%]'} />
    <Skeleton className={'w-full h-[10%]'} />
    <Skeleton className={'w-1/4 h-[5%]'} />
    <Skeleton className={'w-1/2 h-[5%]'} />
    <Skeleton className={'w-full h-[10%]'} />
    <Skeleton className={'w-1/4 h-[5%]'} />
    <Skeleton className={'w-full h-[10%]'} />
  </div>
);
